import React from "react";

const HowItWorks = () => (
  <div className="how-it-works">
    <div className="section1">
      <h2>How it Works</h2>
    </div>
    <div className="item">
      <img src="/png/prelogin1.png" />
    </div>

    <p>
      Order food online for delivery or collection from the best local
      independent restaurants.
    </p>

    <div className="item">
      <img src="/png/prelogin2.png" />
    </div>
    <p>
      Support local and earn Local eCoin rewards with every order. 
      Local Loyalty pays
    </p>

    <div className="item">
      <img src="/png/prelogin3.png" />
    </div>

    <p>
      Save and spend your Local E eCoins online at your favourite restaurants,
      just like cash.
    </p>
    <h5>Order. Eat. Reward. Repeat.</h5>
  </div>
);

export default HowItWorks;
